/* jshint maxstatements: 31 */
/* eslint-disable */
import PageScrollHandler from '@js/utils/intersection-observer';
(function() {
  var $ = require('jquery');
  var Handlebars = require('handlebars');
  require('./custom-handlebars-helpers');
  require('history.js');

  if ($('#ArticlesTemplate').length === 0) {
    return;
  }

  var currentDocID = $('#ArticlesList .docID input[type="hidden"]').val();
  var articleType = $('#ArticlesList .articleTypeFilter input[type="hidden"]').val();

  var divisionCatID = 0;

  if ($('.division-filter select').find('option:selected').length > 0) {
    divisionCatID = $('.division-filter select')
      .find('option:selected')
      .val();
  }
  var isMediaHub = $('#ArticlesList .isMediaHub input[type="hidden"]').val();
  var showOnlyChildArticles = $('#ArticlesList .showOnlyChildArticles input[type="hidden"]').val();
  var showBlogPosts = $('#ArticlesList .showBlogPosts input[type="hidden"]').val();

  var $itemCont = $('#ArticlesList .replaced');
  var $loadMore = $('#ArticlesList #LoadMore');
  var skip = 0;
  var take = 4;
  var source = $('#ArticlesTemplate').html();
  var template = Handlebars.compile(source);
  var year = '';

  initialise();

  /** Initialise. */
  function initialise() {
    $('#ArticlesList .orig').hide();

    $('.division-filter select').change(function() {
      skip = 0;
      divisionCatID = $(this)
        .find('option:selected')
        .val();
      load(skip, take, divisionCatID, year, true);
    });

    /* Controls */
    $loadMore.click(function(e) {
      load(skip, take, divisionCatID, year, false);
      setTimeout(function() {}, 50);
      return false;
    });

    $('.date-filter a').click(function() {
      skip = 0;
      if (
        $(this)
          .closest('li')
          .hasClass('active')
      ) {
        year = '';
        $(this)
          .closest('li')
          .removeClass('active');
      } else {
        year = $(this)
          .attr('href')
          .replace('#', '');

        $(this)
          .closest('ul')
          .find('li')
          .removeClass('active');
        $(this)
          .closest('li')
          .addClass('active');
      }
      load(skip, take, divisionCatID, year, true, false);
      return false;
    });

    load(skip, take, divisionCatID, year, true, true);
  }

  /** Load articles. */
  function load(Skip, Take, catID, year, ClearList, FirstLoad) {
    // Default variables.
    ClearList = ClearList || true;
    FirstLoad = FirstLoad || false;

    $('#divPostsLoader').html('<img src="/sitefiles/images/loaded-icon.gif">');
    if (ClearList) {
      $itemCont.empty();
    }

    var queryyear = getParameterByName('year'),
      tag = getParameterByName('tag'),
      pageShow = parseInt(getParameterByName('show'));

    pageShow = Skip + Take;

    // If pageShow is too large it can somehow prevent articles from loading.
    // To prevent this we are reseting the value to 4 if the year is changed.
    if (queryyear !== year) {
      pageShow = 4;
    }

    if (pageShow > 0 && ClearList) {
      Take = pageShow;
    }

    if (FirstLoad) {
      if (queryyear.length > 0) {
        year = queryyear;
      }
    }

    WebService.LoadArticles(
      0,
      Take,
      currentDocID,
      articleType,
      catID,
      year,
      tag,
      isMediaHub,
      showOnlyChildArticles,
      showBlogPosts,
      function(result) {
        if (!FirstLoad) {
          var query = '?show=' + pageShow.toString();

          if (year.length > 0) {
            query = query += '&year=' + year;
          }
          setBrowserUrl(window.location.href.split('?')[0], window.document.title, query);
        }

        $itemCont.append(template(result.Data));
        animateArticles(Take > take && FirstLoad && !result.Data.AllLoaded);
        const thisImg = document.querySelectorAll('.replaced .js-lazy-img');
        if (thisImg !== null && thisImg.length > 0) {
          Array.forEach(thisImg, element => {
            console.log(element);
            PageScrollHandler.registerImageElement(element);
          });
        }
        if (result.Data.AllLoaded === true) {
          $loadMore.hide();
        } else {
          $loadMore.show();
        }
      },
    );

    $('#divPostsLoader').empty();

    skip += Take;
  }

  /** Display articles. */
  function animateArticles(scroll) {
    var lis = [];

    $('.replaced .article-item').each(function() {
      if ($(this).css('opacity') === '0') {
        lis.push(this);
      }
    });

    var delay = 0;
    $(lis).each(function() {
      $(this)
        .delay(delay)
        .animate(
          {
            opacity: 1,
          },
          500,
        );
      delay += 100;
    });

    if (scroll) {
      setTimeout(function() {
        $('html, body').animate(
          {
            scrollTop: $('#LoadMore').offset().top - $(window).height() + 100,
          },
          1200,
        );
      }, 200);
    }
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function setBrowserUrl(url, title, query) {
    if (title === '' || title === undefined) {
      title = document.title;
    }
    History.pushState(url + query, title, url + query);
  }
})();
